import React from 'react';
import { Box, Button, Typography } from '@mui/material';

import { api } from 'src/Api';
import OrderStatusDropDown from './OrderStatusDropDown';

export default function ChangeOrderStatus({ handleClose, property, refreshAdmin }) {
  function AssignStatus(statusSelected, productId) {
    const myHeaders = new Headers();
    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();
    formdata.append('id', productId);
    formdata.append('status', statusSelected);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(api.change_product_status, requestOptions)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          return response.json();
        } else {
          throw new Error(`Failed to update status: ${response.status} ${response.statusText}`);
        }
      })
      .then((result) => {
        refreshAdmin();
      })
      .catch((error) => console.error('Error updating status:', error));
  }

  return (
    <Box p={3} flexDirection={'column'} display={'flex'} flex={1}>
      <Typography py={3} align="center" variant="h5">
        Change Property Status
      </Typography>
      <OrderStatusDropDown
        alreadyRole={property?.status}
        fullWidth={true}
        setRole={(statusSelected) => {
          AssignStatus(statusSelected, property?.id);
        }}
      />
      <Button style={{ marginTop: 10 }} color="primary" variant="outlined" onClick={handleClose}>
        Close
      </Button>
    </Box>
  );
}
